import { Injectable } from '@angular/core';

import { RidangoEpic } from '@ridango/core';

import { ActionsObservable } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import { RideBookingsService } from '../ride-bookings.service';
import { RideBookingsActions } from './ride-bookings.actions';

@Injectable()
export class RideBookingsEpics implements RidangoEpic {
    constructor(private actions: RideBookingsActions, private service: RideBookingsService) {
    }

    register() {
        return [this.getRideBookings];
    }

    getRideBookings = (action$: ActionsObservable<any>) =>
        action$.ofType(RideBookingsActions.FETCH_RIDE_BOOKINGS).pipe(
            switchMap(() => {
                return this.service.fetchRideBookings().pipe(
                    map((response) => this.actions.fetchRideBookingsSuccess(response)),
                    catchError((error) => of(this.actions.fetchRideBookingsFail(error)))
                );
            })
        )
}
